import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/network/entry-logged-out/src/components/discover-network/assets/network-image-small-de.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')